import styled from 'styled-components/macro';
import { row_center_both, column, column_center_both } from 'src/App/Styles/styles-helpers';
import { GlobalColors, Rules } from 'src/App/Styles/Globals';

export const CIBitsNumberWrapper = styled.div`
	${row_center_both}
	gap: .2rem;
	background-color: ${GlobalColors.newPurple};
	border-radius: ${Rules.radiusButtonCTA};
	font-size: 0.75em;
	font-weight: 800;
	min-width: 50px;
	flex: 1;
	padding: 1em 0;
	margin-top: -25px;
	img {
		width: 16px;
	}
`;
export const CIGifWrapper = styled.div`
	${row_center_both}
	height: 80px;
	overflow: hidden;
	border-radius: 25px 25px 0 0;
`;
